
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/recurring-clean",
      function () {
        return require("private-next-pages/services/recurring-clean.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/recurring-clean"])
      });
    }
  